import { Button, Typography } from "@mui/material";
import { FC } from "react";
import { GeneralButton } from "../../../common/ui/GeneralButton";

interface CancelBtnProps {
  title: string;
  handleOnClick: () => void;
}

const CancelBtn: FC<CancelBtnProps> = ({ title, handleOnClick }) => {
  return (
    <GeneralButton appVariant="ghost" onClick={handleOnClick}>
      {title}
    </GeneralButton>
  );
};

export default CancelBtn;
